import styled from 'styled-components';
import { IonContent, IonSpinner } from '@ionic/react';

export const EmptyWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RoomTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  cursor: pointer;
  color: #1d201f;
  width: fit-content;
  margin: 0 auto;

  & > div {
    display: flex;
    align-items: center;
    justify-content: center;
    column-gap: 12px;
    font-size: 14px;
  }
`;

export const MessagesWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const VirtuosoStyledItem = styled.div`
  height: auto;
  min-height: 80px;
  padding-bottom: 16px;
  padding-right: 16px;

  & pre {
    padding-right: 16px;
  }
`;

export const StyledIonContent = styled(IonContent)`
  --background: url('./chat_bg.svg') no-repeat center center / cover;
  @media screen and (orientation: landscape) {
    --background: url('./chat_bg_landscape.svg') no-repeat center center / cover;
  }
`;

export const Item = styled.div`
  padding: 0 16px;

  &:first-child {
    margin-top: 16px;
  }
`;

export const StyledSpinner = styled(IonSpinner)`
  margin: 0 auto 30px auto;
  --color: #177590;
  width: 40px;
  height: 40px;
`;

export const BackButton = styled.button`
  background: transparent;
  width: 20px;
  height: 23px;
  color: #000000;
  font-size: 20px;
  padding: 0;
  margin-left: -8px;
`;

export const HeaderInfoTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 12px;
`;

export const CalendarButton = styled.button`
  background: transparent;
  width: 20px;
  height: 20px;
  font-size: 20px;
  color: #000000;
  padding: 0;
`;
